import { render, staticRenderFns } from "./Mostrar.vue?vue&type=template&id=ca7282c6&"
import script from "./Mostrar.vue?vue&type=script&lang=js&"
export * from "./Mostrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports